export default {
    title: "Paint With Music",
    GAC_presents: "Google Arts & Culture presents",
    about01:
        "Paint With Music is an interactive experience which connects two major forms of artistic expressions: painting and musical composition.",
    about02: "With the help of machine learning powered by",
    about03: "Magenta's DDSP library",
    about04:
        "(Differentiable Digital Signal Processing), the movement of your brush strokes is translated into musical notes performed by an instrument of your choice.",
    about05:
        "A wide range of sensorial canvases, from the sky to the ocean, are ready to take your composition to the next level by incorporating special sound effects unique to each ambiance.",
    ok: "Ok",
    share_msg:
        "Turn your paint brush into musical instruments with Google Arts & Culture ",
    change_atmosphere: "Change canvas",
    atmosphere_subtitle: "Where would you like to paint with music?",
    in_the_sky: "In the Sky",
    underwater: "Underwater",
    on_the_street: "On the Street",
    on_paper: "On Paper",
    shared_welcome:
        "Check out my painted musical composition powered by machine learning",
    create_my_own: "Create My Own",
    ios_message01: "To listen to your composition, open",
    ios_message02: "g.co/paintwithmusic",
    ios_message03: "on desktop or an Android device",
    share_your_masterpiece: "Share your masterpiece with the world!",
    try_other_instrument: "Try another instrument!",
    loading_flute: "Unboxing the flute",
    loading_violin: "Tuning the violin",
    loading_saxo: "Polishing the saxophone",
    loading_trumpet: "Warming up the trumpet",
    loading_birds: "Calling the birds",
    loading_AI: "Waking up AI",
    loading_whales: "Fetching the whales",
    loadding_spray: "Shaking the spray cans",
    canvas_full: "Your canvas is full!",
    remove_items: "Try removing some shapes to continue drawing.",
    flute: "Flute",
    violin: "Violin",
    saxophone: "Saxophone",
    trumpet: "Trumpet",
    guitar: "Guitar",
    xylophone: "Xylophone",
    birds: "Birds Stamp",
    whale: "Whale Stamp",
    scratch: "Scratch Stamp",
    yo: " Yo Stamp",
    seal: "Stamp",
    toggle_grid: "Toggle notes guide",
    undo: "Undo",
    clear_canvas: "Clear canvas",
    clear: "Clear",
    back: "Back",
    turn_device: "Please turn your device for a better experience",
    info_scale:
        "This is a heptatonic scale, which means there are 7 notes per octave. The most commonly known heptatonic scales are the major and harmonic minor scales, widely used in Western music.",
    info_japanese_scale:
        "This is a Hirajōshi scale, originated from Japan. Created by Yatsuhashi Kengyō, this scale was adapted from shamisen music and originally used for tuning the koto instrument.",
    atmosphere_warning_title: "Heads up!",
    atmosphere_warning_text: "Changing canvas will reset your painting",
    safari_warning: "For a better experience please try another browser.",
    go_back: "Go back",
    about: "About",
    share: "Share",
    toggle_play_pause: "Toggle Play Pause",
    generating_shared_strokes: "Generating audio",
};